import { Yup } from '../../../../utils';
import { FORM_LOGIN_FIELDS } from '../../../../consts/text/form-login';

export const formSchemaLogin = Yup.object().shape({
    [FORM_LOGIN_FIELDS.FIELD_EMAIL]: Yup.string().email().required(),
    [FORM_LOGIN_FIELDS.FIELD_SENHA]: Yup.string().required(),
});
